module.exports = __webpack_public_path__ + "static/media/add.3d84444b.svg";